import { RootState } from '@AppState/redux-store'
import { Routes } from '@Components/main-app/types'
import { AuthScopes } from '@Generated/back-office-client/src'
import { Container, Section, TabNav } from '@radix-ui/themes'
import { useSelector } from 'react-redux'
import { Link, Outlet, useLocation } from 'react-router-dom'

export const Users = () => {
  const location = useLocation()
  const { currentUser } = useSelector((state: RootState) => state.users)

  const canReadRoles = currentUser?.scopes.includes(AuthScopes.readroles)

  const rolesActive = location.pathname.startsWith('/users/roles')
  const usersActive = !rolesActive

  return (
    <Container>
      <Section size="1">
        <TabNav.Root>
          <TabNav.Link active={usersActive} asChild>
            <Link to={Routes.USERS} replace>
              Users
            </Link>
          </TabNav.Link>
          {canReadRoles ? (
            <TabNav.Link active={rolesActive} asChild>
              <Link to={Routes.ROLES} replace>
                Roles
              </Link>
            </TabNav.Link>
          ) : null}
        </TabNav.Root>
      </Section>
      <Outlet />
    </Container>
  )
}
